import { render, staticRenderFns } from "./hengfengche.vue?vue&type=template&id=110b3767&"
import script from "./hengfengche.vue?vue&type=script&lang=js&"
export * from "./hengfengche.vue?vue&type=script&lang=js&"
import style0 from "./hengfengche.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports